<main class="app">
  <app-banner-main></app-banner-main>

  <section class="app__main-content">
    <router-outlet></router-outlet>
  </section>
</main>

<app-modal-loading [active]="show"></app-modal-loading>